module.exports = __webpack_public_path__ + "assets/img/chihuang50_1.58a9380d.jpg";